import { createAsyncThunk, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit'
import { Auth,  } from 'aws-amplify';
import { RootState } from '../../store/store';
import { Loading } from '../../App/app';
import { feedback } from '../../components/Feedback/feedback';
import { authenticateUser } from '../../store/api/authenticate-user';
import i18n from '../../i18n/i18n';
import apiPasswordPolicyMessage from "../../i18n/api/password-policy";

export interface SignInState {
  loading: Loading,
  currentRequestId: string,
  error: SerializedError | null,
}

const initialState: SignInState = {
  loading: 'idle',
  currentRequestId: '',
  error: null,
}

interface Attributes {
  [id:string]: any,
}

interface CognitoUser {
  attributes: Attributes,
  authenticationFlowType: string,
}

export interface Credentials {
  username: string,
  password: string,
}

export const fetchUser = createAsyncThunk(
  'signIn/fetchUser',
  async ( credentials: Credentials, thunkAPI ) => {
    const state = thunkAPI.getState() as RootState;
    const { currentRequestId, loading } = state.pages.signIn;

    if (loading !== 'pending' || thunkAPI.requestId !== currentRequestId) return

    return Auth.signIn( credentials.username, credentials.password ).then( cognitoUser => {
      thunkAPI.dispatch( authenticateUser());

      return true

    }).catch( error => {
      const apiT = i18n.getFixedT( null, 'api' );
      thunkAPI.dispatch( feedback( { message: apiT(apiPasswordPolicyMessage( error.message )), severity: 'error' } ));
      return false;
    })
  }
)

export const signInSlice = createSlice({
  name: 'signIn',
  initialState,
  reducers: {
  },
  extraReducers: ( builder ) => {
      builder.addCase(fetchUser.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending'
          state.currentRequestId = action.meta.requestId
        }
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        const { requestId } = action.meta
        if ( state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle'
          state.currentRequestId = ''
        }
      })
      .addCase(fetchUser.rejected, ( state, action, ) => {
        const { requestId } = action.meta
        if (
          state.loading === 'pending' &&
          state.currentRequestId === requestId
        ) {
          state.loading = 'idle'
          state.error = action.error
          state.currentRequestId = ''
        }
      })

  },
})

export const { } = signInSlice.actions

export default signInSlice.reducer
